// Copyright (c) Ensho Health, 2021 to present

const INDEXED_DB_NAME = 'EnshoCodDatabase';
const OBJECT_STORE_NAME = 'CodKeystore';
const KEY_NAME = 'CodKey';

export function removeKey() {
  return new Promise((resolve, reject) => {
    let db;
    const openRequest = window.indexedDB.open(INDEXED_DB_NAME, 1);
    openRequest.onerror = function onerror(event) {
      reject(event.error);
    };
    openRequest.onupgradeneeded = function onupgradeneeded(event) {
      const upgradeDb = event.target.result;
      upgradeDb.createObjectStore(OBJECT_STORE_NAME);
    };
    openRequest.onsuccess = function onsuccess(event) {
      db = event.target.result;

      const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
      const addRequest = tx.objectStore(OBJECT_STORE_NAME).delete(KEY_NAME);
      addRequest.onsuccess = () => resolve();
      addRequest.onerror = (ev) => reject(ev);
    };
  });
}

export function storeKey(key) {
  return new Promise((resolve, reject) => {
    let db;
    const openRequest = window.indexedDB.open(INDEXED_DB_NAME, 1);
    openRequest.onerror = function onerror(event) {
      reject(event.error);
    };
    openRequest.onupgradeneeded = function onupgradeneeded(event) {
      const upgradeDb = event.target.result;
      upgradeDb.createObjectStore(OBJECT_STORE_NAME);
    };
    openRequest.onsuccess = function onsuccess(event) {
      db = event.target.result;

      const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
      const addRequest = tx.objectStore(OBJECT_STORE_NAME).put(key, KEY_NAME);
      addRequest.onsuccess = (ev) => resolve(ev.target.result);
      addRequest.onerror = (ev) => reject(ev);
    };
  });
}

export function getKey() {
  return new Promise((resolve, reject) => {
    let db;
    const openRequest = window.indexedDB.open(INDEXED_DB_NAME, 1);
    openRequest.onerror = function onerror(event) {
      reject(event.error);
    };
    openRequest.onupgradeneeded = function onupgradeneeded(event) {
      const upgradeDb = event.target.result;
      upgradeDb.createObjectStore(OBJECT_STORE_NAME);
    };
    openRequest.onsuccess = function onsuccess(event) {
      db = event.target.result;

      const tx = db.transaction(OBJECT_STORE_NAME, 'readonly');
      const addRequest = tx.objectStore(OBJECT_STORE_NAME).get(KEY_NAME);
      addRequest.onsuccess = (ev) => resolve(ev.target.result);
    };
  });
}
